<template>
    <section>
        <div id="commentContent" class="flexContainer fd-c">
            <div class="commentList f-00">
                <div class="flexContainer fd-c ac-c mt25" v-for="comment in comments" :key="comment.id">
                    <div class="flexContainer fd-r">
                        <div class="userInfo">{{ comment.createdUser.initial }}</div>
                        <div class="commentInfo full">
                            <span class="bold fleft">{{ comment.createdUser.firstname }} {{ comment.createdUser.lastname }}</span
                            ><br /><br />
                            <span class="fleft">{{ comment.content }}</span> <br /><br />
                            {{ comment.createdAt }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="flexContainer full fd-c commentArea">
                <textarea id="commentZone" class="full" rows="8" placeholder="Your comment" v-model="newComment.content"></textarea>
                <div class="rel">
                    <button class="btn abs pointer sendComment txtCenter" @click="sendComment">{{ $t("comments.send") }}</button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
const d3 = require("d3"); // eslint-disable-line no-unused-vars
import httpService from "../../service";

//    import Vuex from 'vuex'

export default {
    data: () => ({
        comments: [],
        newComment: {
            content: null
        }
    }),
    watch: {},
    methods: {
        sendComment() {
            this.$store.state.plano.data.commentNb = this.comments.length + 1;
            httpService.post("/plano/" + this.$route.params.id + "/comments", JSON.stringify(this.newComment)).then(response => {
                this.comments.push(response);
                this.newComment.content = null;
            });
        }
    },
    mounted() {},
    created() {
        httpService.get("/plano/" + this.$route.params.id + "/comments").then(response => {
            this.comments = response.data;
        });
    }
};
</script>

<style lang="scss" scoped>
#commentContent {
    background: #fff;
    height: calc(100vh - 177px);
    // width:440px;
    font-size: 1.2rem;
    .commentList {
        height: calc(100vh - 420px);
        border-bottom: 1px solid #eee;
        padding: 0 15px;
        overflow-y: auto;
        .userInfo {
            height: 50px;
            width: 60px;
            border-radius: 50%;
            text-align: center;
            line-height: 50px;
            border: 1px solid #dddddd;
        }
        .commentInfo {
            padding: 10px;
            text-align: right;
            text-justify: auto;
            background: #f6f6f6;
            border-radius: 3px;
            margin-left: 15px;
        }
    }
    .commentArea {
        padding: 15px 25px;
        bottom: 0;
        #commentZone {
            font-family: Roboto;
            font-size: 14px;
            color: black;
            resize: none;
            bottom: 15px;
            border: 1px solid #dedede;
            border-bottom: 2px solid #343434;
            padding: 15px;
            margin-bottom: 15px;
        }
        .sendComment {
            max-width: 200px;
            right: 0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// Comments.vue?0c10fdc0